import { useTheme } from "@hooks";

export const Back = () => {
  const { theme } = useTheme();

  return (
    <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5263 20L0 10L10.5263 0L12 1.425L2.97368 10L12 18.575L10.5263 20Z"
        fill={theme.icon.default}
      />
    </svg>
  );
};
